import CountryMapContainer from './CountryMapContainer';

export default CountryMapContainer;